<template>
  <div class="home-page">
    <div class="header container">
      <el-row>
        <el-col :span="8">
          <div class="grid-content-left">
            <main-nav></main-nav>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">&nbsp;</div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content-right">
            <login :isAtHome="true" ref="login"></login>
          </div>
        </el-col>
      </el-row>
    </div>
    <ul class="gameIntroduce">
      <li v-for="item in gameIntroduceList" :key="item.name">
        <router-link :to="item.url">
          <div class="img-wrap">
            <img :src="item.picLink" alt="" />
          </div>
          <p>{{ item.name }}</p>
        </router-link>
      </li>
    </ul>
    <div class="support">
      <ul>
        <li @click="goHref1()">
          <div class="img-wrap">
            <img :src="require('../assets/images/home/support/img11.png')" alt="" />
          </div>
          <div class="desc">
            <p class="title">APP下载</p>
            <p class="enTitle">APP Download</p>
          </div>
        </li>
        <li @click="goHref(item)" v-for="item in depositList" :key="item.name">
          <div class="img-wrap">
            <img :src="item.picLink" alt="" />
          </div>
          <div class="desc">
            <p class="title">{{ item.name }}</p>
            <p class="enTitle">{{ item.subName }}</p>
          </div>
        </li>
      </ul>
    </div>
    <jackpot></jackpot>
    <div class="container introduce">
      <p class="content">
        竞技奢华之旅，尽在9570娱乐
        9570.top，亚洲最具公信力线上娱乐平台，无尽奖赏、尊贵礼遇，宾至如归服务，等您体验！
      </p>
      <router-link class="learnMore" to="/discounts"></router-link>
    </div>
    <home-pendant></home-pendant>
    <home-float></home-float>

  </div>
</template>

<script>
/*eslint-disable*/
import { mapActions, mapState, mapMutations } from "vuex";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { common } from "@/common/index";
import MainNav from "../components/nav/main-nav";
import Login from "../components/base/login/login";
import jackpot from "../components/base/jackpot/jackpot";
import { MessageBox, Conf } from "element-ui";
import HomePendant from "../components/pendant/home-pendant";
import homeFloat from "../components/pendant/homeFloat";

export default {
  name: "HOME",
  components: {
    jackpot,
    Login,
    swiper,
    swiperSlide,
    MainNav,
    HomePendant,
    homeFloat,
  },
  data() {
    return {
      password: "",
      newPassword: "",
      rePassword: "",
      isLoading: false,
      showforget: false,
      advertisingShow: true,
      // 游戏推荐列表
      gameIntroduceList: [
        {
          picLink: require("../assets/images/home/gamelist/01.png"),
          name: "KY开元棋牌",
          url: "/chess",
        },
        {
          picLink: require("../assets/images/home/gamelist/02.png"),
          name: "PA女优厅",
          url: "/liveCasino",
        },
        {
          picLink: require("../assets/images/home/gamelist/03.png"),
          name: "BB旗舰厅",
          url: "/liveCasino",
        },
        {
          picLink: require("../assets/images/home/gamelist/04.png"),
          name: "百家乐",
          url: "/liveCasino",
        },
        {
          picLink: require("../assets/images/home/gamelist/kg01.png"),
          name: "炸金花",
          url: "/chess",
        },
        {
          picLink: require("../assets/images/home/gamelist/kg02.png"),
          name: "抢庄牛牛",
          url: "/chess",
        },
      ],
      // 存款列表
      depositList: [
        // {
        //   picLink: require("../assets/images/home/support/img11.png"),
        //   name: "APP下载",
        //   isRequire: false,
        //   subName: "APP Download",
        //   src: "https://ieikba.com",
        //   url: "",
        // }, // window.location.protocol+'//'+window.location.host+'/#/download'
        {
          picLink: require("../assets/images/home/support/img12.png"),
          name: "支付宝支付",
          isRequire: true,
          subName: "Pay with Ali-Pay",
          src: "",
          url: "/mine/capital/deposit",
        },
        {
          picLink: require("../assets/images/home/support/img13.png"),
          name: "微信支付",
          isRequire: true,
          subName: "WeChat payment",
          src: "",
          url: "/mine/capital/deposit",
        },
        {
          picLink: require("../assets/images/home/support/imgqq.png"),
          name: "QQ钱包支付",
          isRequire: true,
          subName: "QQ wallet payment",
          src: "",
          url: "/mine/capital/deposit",
        },
        {
          picLink: require("../assets/images/home/support/img15.png"),
          name: "快速充值中心",
          isRequire: true,
          subName: "Fast recharge center",
          src: "",
          url: "/mine/capital/deposit",
        },
      ],
      // 介绍模块
      // introduceLogo: require('../assets/images/home/introduce/boot-logo.png'),

      // 下载
      downloadUrl:
        window.location.protocol + "//" + window.location.host + "/#/download",
      downloadConfig: {
        width: 60, // 设置宽度
        height: 60, // 设置高度
        text: "",
      },
      changeTimer1: "",
    };
  },

  computed: {
    ...mapState({
      UUID: (state) => state.UUID,
      isLogin: (state) => state.isLogin,
      frontType: (state) => state.frontType,
      indexNav: (state) => state.indexNav,
      appJump: (state) => state.linkList.appJump,
      jin_sha_global_login_state: (state) => state.jin_sha_global_login_state,
      appDownload: (state) => state.linkList.appDownload,
    }),

  },

  methods: {
    ...mapMutations(["CLOSE_INDEX_AD", "TOP_VIEW"]),
    ...mapActions(["setIndexNav", "getFirstInfo", "IS_LOGIN_FOCUS"]),
    goHref(item) {
      if (item.isRequire) {
        // 要求登录

        if (this.isLogin) {
          // 已经登陆
          this.$router.push({ path: item.url });
        } else {
          // 未登陆 => 记录目标地址
          common.jinsha_GoGame(item.url, this.isLogin, this.UUID);
        }
      } else {
        // 不要求登录
        if (item.url) {
          this.$router.push({ path: item.url });
        } else {
          window.open(item.src);
        }
      }
    },
    goHref1(){
      window.open(this.appDownload);
    }

  },

  activated() {
    this.isLogin && this.$refs.login && this.$refs.login.refresh(true)
  }
};
</script>

<style scoped lang="scss">

@keyframes flipInX {
  from {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }

  60% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    -webkit-transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
}
@import "../style/variable.scss";
.home-page {
  position: relative;
  background: url("../assets/images/home/bg.jpg") no-repeat center top;
  .header {
    height: 500px;
    .grid-content-right {
      animation: flipInX 1s ease-in-out;
    }
  }
  .gameIntroduce {
    width: 800px;
    margin: auto;
    text-align: center;
    li {
      width: 16%;
      display: inline-block;
      a {
        display: inline-block;
        color: #fff;
        font-size: 14px;
        transition: all 0.3s linear;
        &:hover {
          transform: translateY(-20px);
          color: #ff0;
        }
        .img-wrap {
          height: 90px;
          line-height: 90px;
          img {
            vertical-align: middle;
          }
        }
      }
    }
  }
  .support {
    ul {
      display: flex;
      width: 1000px;
      height: 115px;
      margin: 95px auto 0;
      padding-top: 33px;
      background: url("../assets/images/home/support/deposit_bg.png") no-repeat
        center top;
      li {
        cursor: pointer;
        height: 70px;
        display: inline-block;
        width: 20%;
        padding-left: 5px;
        > div {
          line-height: 70px;
          vertical-align: middle;
          display: inline-block;
        }
        .img-wrap {
          width: 60px;
          text-align: center;
        }
        .desc {
          .title {
            color: #fff1bb;
          }
          .enTitle {
            color: #ba4040;
          }
          p {
            color: #ba4040;
            line-height: 20px;
            font-size: 12px;
          }
        }
        &:hover {
          .enTitle {
            color: #fff1bb;
          }
        }
      }
    }
  }
  .introduce {
    height: 209px;
    position: relative;
    margin-top: 25px;
    padding: 60px 30px 35px;
    background: url("../assets/images/home/introduce/about_bg.png");
    .content {
      margin-bottom: 18px;
      width: 450px;
      color: #999;
      line-height: 2;
      text-align: center;
    }
    .learnMore {
      display: block;
      width: 130px;
      height: 36px;
      background: url("../assets/images/home/introduce/img16.png");
      &:hover {
        background-position-y: 36px;
      }
    }
  }
}
</style>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/build08/views/HOME.vue